import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ArticlesGrid from './components/ArticlesGrid';
import TrendingSection from './components/TrendingSection';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <CategoryGrid />
      <ArticlesGrid />
      <TrendingSection />
      <CTASection />
      <TestimonialSection />
      <FAQSection />
      <Footer />
    </main>
  );
}